import { Button, Typography } from '@/components/common';
import * as React from 'react';

interface CaseInitiationCardProps {
	title: string;
	subtitle: string;
	titleCard: string;
	subtitleCard: string;
	buttonLabel: string;
	buttonIcon: string;
	onClick: () => void;
	className?: string;
	buttonDisabled?: boolean;
	buttonCustom?: React.ReactNode;
}

export const CaseInitiationCard: React.FC<CaseInitiationCardProps> = ({
	subtitle,
	title,
	buttonLabel,
	titleCard,
	subtitleCard,
	onClick,
	className,
	buttonIcon,
	buttonDisabled,
	buttonCustom,
}) => {
	return (
		<div className={className}>
			<Typography type="semibold-16" className="text-black">
				{title}
			</Typography>
			<Typography type="regular-12" className="text-opacity-black mt-3 mb-6">
				{subtitle}
			</Typography>

			<div className="flex justify-between items-center gap-x-2 bg-gray-15 px-4 py-[18px] border border-grey-100 rounded-2xl">
				<div>
					<Typography type="regular-14" className="text-black">
						{titleCard}
					</Typography>
					<Typography type="regular-12" className="text-opacity-black mt-1">
						{subtitleCard}
					</Typography>
				</div>

				{buttonCustom ? (
					buttonCustom
				) : (
					<Button
						label={buttonLabel}
						size="fit"
						decoration="primary"
						onClick={onClick}
						iconLeft
						icon={buttonIcon}
						classNameButton="!w-4 !h-4"
						disabled={buttonDisabled}
					/>
				)}
			</div>
		</div>
	);
};
